import React from "react";
import Modal from "react-modal";
import Cards from "react-credit-cards-2";
import logoLumos from "../../../assets/img/logo_lumos.png";
import "react-credit-cards-2/es/styles-compiled.css";

class Step3 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      termsAccepted: false,
    };
  }

  componentDidMount() {
    // Configurar o elemento raiz do modal
    if (typeof window !== "undefined" && document.body) {
      Modal.setAppElement(document.body);
    }

    setTimeout(() => {
      this.enableInputs();
      this.startInputKeepAlive();
    }, 100);
  }

  componentDidUpdate() {
    setTimeout(() => {
      this.enableInputs();
    }, 0);
  }

  componentWillUnmount() {
    if (this.inputKeepAliveInterval) {
      clearInterval(this.inputKeepAliveInterval);
    }
  }

  startInputKeepAlive = () => {
    if (this.inputKeepAliveInterval) {
      clearInterval(this.inputKeepAliveInterval);
    }

    this.inputKeepAliveInterval = setInterval(() => {
      if (!this.containerRef) return;
      const inputs = this.containerRef.querySelectorAll('input[type="text"]');
      inputs.forEach((input) => {
        if (input.disabled) {
          input.disabled = false;
          input.removeAttribute("disabled");
        }
        input.style.pointerEvents = "auto";
        input.style.cursor = "text";
      });
    }, 100);
  };

  enableInputs = () => {
    if (!this.containerRef) return;
    const inputs = this.containerRef.querySelectorAll('input[type="text"]');
    inputs.forEach((input) => {
      input.disabled = false;
      input.readOnly = false;
      input.removeAttribute("disabled");
      input.removeAttribute("readonly");
      input.style.pointerEvents = "auto";
      input.style.cursor = "text";
      input.style.zIndex = "999999";
      input.style.position = "relative";
    });
  };

  handleInputChange = (field, value) => {
    this.props.onInputChange("step3", field, value);
  };

  handleTermsChange = (e) => {
    this.setState({ termsAccepted: e.target.checked });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    // Abrir modal de pagamento ao invés de alert
    this.props.onSubmit(e);
  };

  render() {
    const { data, allData, payment, t, getPrice, getBasePrice, discount } =
      this.props;
    const { step1, step2 } = allData || {};
    const basePrice = getBasePrice ? getBasePrice() : 0;
    const finalPrice = getPrice ? getPrice() : basePrice;
    const discountPercentage = discount?.percentage || 0;
    const discountAmount =
      discountPercentage > 0 ? (basePrice * discountPercentage) / 100 : 0;
    const total = finalPrice.toFixed(2);
    const translate = t || ((key) => key);
    const canPay = Boolean(this.props.canPay);
    const mode = this.props.paymentMode || "charge_and_save";
    const saveCardConsent = Boolean(this.props.saveCardConsent);
    const primaryButtonText =
      mode === "save_only"
        ? translate("saveCard")
        : `${translate("payAmount")}${total}`;

    return (
      <div
        className="step-container"
        ref={(ref) => {
          this.containerRef = ref;
        }}
        style={{ pointerEvents: "auto" }}
      >
        <div className="wizard-logo-container">
          <img src={logoLumos} alt="Lumos" className="wizard-logo" />
        </div>
        <div className="step-header">
          <h1 className="step-title">{translate("step3Title")}</h1>
          <p className="step-subtitle">{translate("step3Subtitle")}</p>
        </div>

        {/* Indicador de Progresso */}
        <div className="progress-indicator">
          {[1, 2, 3].map((step) => (
            <div
              key={step}
              className={`progress-bar ${step <= this.props.currentStep ? "active" : ""
                }`}
            />
          ))}
        </div>

        <form className="step-form" onSubmit={this.handleSubmit}>
          <div className="review-section">
            {step1 && (
              <>
                <div className="review-item">
                  <span className="review-label">
                    {translate("reviewName")}
                  </span>
                  <span className="review-value">
                    {step1.nomeCompleto || ""}
                  </span>
                </div>
                <div className="review-item">
                  <span className="review-label">
                    {translate("reviewEmail")}
                  </span>
                  <span className="review-value">{step1.email || ""}</span>
                </div>
                <div className="review-item">
                  <span className="review-label">
                    {translate("reviewPhone")}
                  </span>
                  <span className="review-value">{step1.celular || ""}</span>
                </div>
              </>
            )}
            {step2 && (
              <>
                <div className="review-item">
                  <span className="review-label">
                    {translate("reviewCampus")}
                  </span>
                  <span className="review-value">
                    {step2.campusOption || ""}
                  </span>
                </div>
                <div className="review-item">
                  <span className="review-label">
                    {translate("reviewClasses")}
                  </span>
                  <span className="review-value">
                    {step2.classOption || ""}
                  </span>
                </div>
              </>
            )}
            {basePrice > 0 && (
              <>
                {discountPercentage > 0 ? (
                  <>
                    <div className="review-item">
                      <span className="review-label">{translate("price")}</span>
                      <span className="review-value">
                        ${basePrice.toFixed(2)}
                      </span>
                    </div>
                    <div className="review-item review-discount">
                      <span className="review-label">
                        {translate("discount")}
                      </span>
                      <span
                        className="review-value"
                        style={{ color: "#28a745" }}
                      >
                        -${discountAmount.toFixed(2)} ({discountPercentage}%)
                      </span>
                    </div>
                    <div className="review-item review-price">
                      <span className="review-label">
                        {translate("finalPrice")}
                      </span>
                      <span
                        className="review-value"
                        style={{ fontWeight: "bold", fontSize: "1.1em" }}
                      >
                        {discountPercentage === 100 ? (
                          <>{translate("contactFinanceDepartment")}</>
                        ) : (
                          <>
                            {translate("priceInstallment")} ${total}
                          </>
                        )}
                      </span>
                    </div>
                  </>
                ) : (
                  <div className="review-item review-price">
                    <span className="review-label">{translate("price")}</span>
                    <span className="review-value">
                      {translate("priceInstallment")} ${total}
                    </span>
                  </div>
                )}
              </>
            )}
          </div>

          {/* Checkbox de Termos e Condições */}
          <div className="consent-section">
            <input
              type="checkbox"
              id="termsAcceptance"
              className="consent-checkbox"
              checked={this.state.termsAccepted}
              onChange={this.handleTermsChange}
              style={{
                pointerEvents: "auto",
                cursor: "pointer",
              }}
            />
            <label htmlFor="termsAcceptance" className="consent-label">
              {translate("termsText")}{" "}
              <a
                href="/terms-of-use.html"
                target="_blank"
                rel="noopener noreferrer"
                className="consent-link"
                onClick={(e) => e.stopPropagation()}
              >
                {translate("termsLink")}
              </a>
              .
            </label>
          </div>

          <div className="button-group">
            <button
              type="button"
              className="prev-button"
              onClick={this.props.onPrev}
            >
              {translate("back")}
            </button>
            <button
              type="submit"
              className="submit-button"
              disabled={!this.state.termsAccepted}
              style={{
                opacity: this.state.termsAccepted ? 1 : 0.5,
                cursor: this.state.termsAccepted ? "pointer" : "not-allowed",
              }}
            >
              {discountPercentage === 100
                ? translate("submit")
                : translate("pay")}
            </button>
          </div>
        </form>

        {/* Modal de Pagamento */}
        <Modal
          isOpen={payment?.modalPaymentIsOpen || false}
          onRequestClose={this.props.toggleModalPayment}
          contentLabel="Payment Modal"
          overlayClassName="payment-modal-overlay"
          className="payment-modal-content"
          shouldCloseOnOverlayClick={false}
          shouldCloseOnEsc={false}
        >
          <div className="payment-modal-wrapper">
            <h2>{translate("payment")}</h2>
            <hr />

            <div
              className="row form-inner-area step-box"
              style={{ paddingTop: "20px" }}
            >
              <div className="col-md-5">
                <div className="wizard-form-input position-relative form-group has-float-label">
                  <div className="row form-inner-area">
                    <div className="col-md-12">
                      <Cards
                        cvc={payment?.cardInformation?.cvc || ""}
                        expiry={payment?.cardInformation?.expiry || ""}
                        focused={payment?.cardInformation?.focused || ""}
                        name={payment?.cardInformation?.name || ""}
                        number={payment?.cardInformation?.number || ""}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-7">
                <div className="wizard-form-input position-relative form-group has-float-label">
                  <div className="row form-inner-area">
                    <div className="col-md-12">
                      <div className="wizard-form-input position-relative form-group has-float-label">
                        <label
                          style={{ fontSize: "15px" }}
                          className="label-input"
                        >
                          {translate("cardName")}
                        </label>
                        <input
                          style={{ padding: "12px", height: "37px" }}
                          type="text"
                          className="form-control"
                          name="name"
                          placeholder={translate("cardNamePlaceholder")}
                          value={payment?.cardInformation?.name || ""}
                          onChange={(e) => {
                            e.stopPropagation();
                            this.props.handleCardInputChange(e);
                          }}
                          onChangeCapture={(e) => e.stopPropagation()}
                          onInputCapture={(e) => e.stopPropagation()}
                          onFocus={(e) => {
                            e.stopPropagation();
                            this.props.handleInputFocus(e);
                          }}
                          onFocusCapture={(e) => e.stopPropagation()}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row form-inner-area">
                    <div className="col-md-6">
                      <div className="wizard-form-input position-relative form-group has-float-label">
                        <label
                          style={{ fontSize: "15px" }}
                          className="label-input"
                        >
                          {translate("cardNumber")}
                        </label>
                        <input
                          style={{ padding: "12px", height: "37px" }}
                          type="text"
                          className="form-control"
                          name="number"
                          pattern="[\d| ]{16,22}"
                          placeholder={translate("cardNumberPlaceholder")}
                          value={payment?.cardInformation?.number || ""}
                          onChange={(e) => {
                            e.stopPropagation();
                            this.props.handleCardInputChange(e);
                          }}
                          onChangeCapture={(e) => e.stopPropagation()}
                          onInputCapture={(e) => e.stopPropagation()}
                          onFocus={(e) => {
                            e.stopPropagation();
                            this.props.handleInputFocus(e);
                          }}
                          onFocusCapture={(e) => e.stopPropagation()}
                        />
                      </div>
                    </div>

                    <div className="col-md-3">
                      <div className="wizard-form-input position-relative form-group has-float-label">
                        <label
                          style={{ fontSize: "15px" }}
                          className="label-input"
                        >
                          {translate("expiry")}
                        </label>
                        <input
                          style={{ padding: "12px", height: "37px" }}
                          type="text"
                          className="form-control"
                          name="expiry"
                          placeholder={translate("expiryPlaceholder")}
                          value={payment?.cardInformation?.expiry || ""}
                          onChange={(e) => {
                            e.stopPropagation();
                            this.props.handleCardInputChange(e);
                          }}
                          onChangeCapture={(e) => e.stopPropagation()}
                          onInputCapture={(e) => e.stopPropagation()}
                          onFocus={(e) => {
                            e.stopPropagation();
                            this.props.handleInputFocus(e);
                          }}
                          onFocusCapture={(e) => e.stopPropagation()}
                          pattern="\d\d/\d\d"
                        />
                      </div>
                    </div>

                    <div className="col-md-3">
                      <div className="wizard-form-input position-relative form-group has-float-label">
                        <label
                          style={{ fontSize: "15px" }}
                          className="label-input"
                        >
                          {translate("cvc")}
                        </label>
                        <input
                          style={{ padding: "12px", height: "37px" }}
                          type="text"
                          className="form-control"
                          name="cvc"
                          placeholder={translate("cvcPlaceholder")}
                          value={payment?.cardInformation?.cvc || ""}
                          onChange={(e) => {
                            e.stopPropagation();
                            this.props.handleCardInputChange(e);
                          }}
                          onChangeCapture={(e) => e.stopPropagation()}
                          onInputCapture={(e) => e.stopPropagation()}
                          pattern="\d{3,4}"
                          onFocus={(e) => {
                            e.stopPropagation();
                            this.props.handleInputFocus(e);
                          }}
                          onFocusCapture={(e) => e.stopPropagation()}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row form-inner-area">
                    <div className="col-md-6">
                      <div className="wizard-form-input position-relative form-group has-float-label">
                        <label
                          style={{ fontSize: "15px" }}
                          className="label-input"
                        >
                          {translate("postalCode")}
                        </label>
                        <input
                          style={{ padding: "12px", height: "37px" }}
                          type="text"
                          className="form-control"
                          name="postalCode"
                          placeholder={translate("postalCodePlaceholder")}
                          value={payment?.cardInformation?.postalCode || ""}
                          onChange={(e) => {
                            e.stopPropagation();
                            this.props.handleCardInputChange(e);
                          }}
                          onChangeCapture={(e) => e.stopPropagation()}
                          onInputCapture={(e) => e.stopPropagation()}
                          onFocus={(e) => {
                            e.stopPropagation();
                            this.props.handleInputFocus(e);
                          }}
                          onFocusCapture={(e) => e.stopPropagation()}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row form-inner-area">
                    <div className="col-md-12">
                      <div
                        className="wizard-form-input position-relative form-group has-float-label"
                        style={{ marginTop: "10px" }}
                      >
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <input
                            type="checkbox"
                            id="saveCardConsent"
                            checked={saveCardConsent}
                            disabled={payment?.isPaying}
                            onChange={(e) => {
                              e.stopPropagation();
                              this.props.onSaveCardConsentChange(e);
                            }}
                            onChangeCapture={(e) => e.stopPropagation()}
                            onClick={(e) => {
                              e.stopPropagation();
                              e.stopImmediatePropagation();
                            }}
                            style={{
                              pointerEvents: "auto",
                              cursor: "pointer",
                              marginRight: "10px",
                              width: "16px",
                              height: "16px",
                              minWidth: "16px",
                              minHeight: "16px",
                              padding: "0",
                              appearance: "checkbox",
                              WebkitAppearance: "checkbox",
                            }}
                          />
                          <label
                            htmlFor="saveCardConsent"
                            style={{ margin: 0, cursor: "pointer", marginTop: "-10px" }}
                            onClick={(e) => e.stopPropagation()}
                          >
                            {translate("saveCardConsentLabel")}
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <hr />

            {payment?.paymentError && payment.paymentError.length > 0 && (
              <div className="row form-inner-area">
                <div className="col-md-12">
                  <div className="wizard-form-input position-relative form-group has-float-label">
                    <div className="alert alert-danger" role="alert">
                      {payment.paymentError}
                    </div>
                  </div>
                </div>
              </div>
            )}

            <div className="row form-inner-area" style={{ float: "right" }}>
              <div className="col-md-12">
                <div className="wizard-form-input position-relative form-group has-float-label">
                  <button
                    type="button"
                    color="primary"
                    className="btn btn-light"
                    style={{ margin: "0" }}
                    onClick={this.props.toggleModalPayment}
                    disabled={payment?.isPaying}
                  >
                    {translate("close")}
                  </button>

                  <button
                    type="button"
                    color="danger"
                    className="btn btn-success"
                    style={{ marginLeft: "15px" }}
                    onClick={this.props.pay}
                    disabled={
                      payment?.isPaying ||
                      !canPay ||
                      (mode === "save_only" && !saveCardConsent)
                    }
                  >
                    {payment?.isPaying
                      ? translate("processing")
                      : primaryButtonText}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

export default Step3;
